import { forwardRef, type Ref, type SVGProps } from "react";

function Check(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 176 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_48_10666)">
        <circle cx="88.5" cy="60" r="50" stroke="url(#paint0_linear_48_10666)" strokeWidth="20" />
        <path
          d="M74.0557 62.5761L83.389 72.1215L105.167 46.667"
          stroke="#0C1C43"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_48_10666"
          x1="88.5"
          y1="10"
          x2="88.5"
          y2="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#98CCFB" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="clip0_48_10666">
          <rect x="38.5" y="10" width="100" height="100" rx="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(Check);
export default ForwardRef;
